import React, { useState } from "react";
import { cn } from "@/utils/utils";
import { Commercials } from "@/pages/deals/types";
import CompanyCommercial from "@/pages/companies/components/CompanyCommercials/CompanyCommercial";
import IconContainer from "@/components/ui/icon-container";
import { ChevronDown, Product as ProductIcon } from "@dreamhub/designsystem/icons";
import Text from "@/components/ui/text";
import { getProductNameById } from "@/pages/deals/helpers";
import Badge from "@/components/ui/badge";
import {
  GROUP_BY_CONTRACT_EXPIRATION,
  GROUP_BY_PRODUCT
} from "@/pages/companies/components/CompanyCommercials/PastContracts";
import { Product } from "@/pages/settings/components/settingsItems/hooks/types";
import { IconButton } from "@/components/ui/icon-button";
import { map } from "lodash";

interface Props {
  group: string;
  commercials: Commercials[];
  groupedBy: string[];
  isMultiProduct?: boolean;
  products?: Product[];
}

const CompanyCommercialGroup: React.FC<Props> = ({
  group,
  commercials,
  groupedBy,
  isMultiProduct,
  products
}) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const productName = getProductNameById(
    groupedBy[0] === GROUP_BY_PRODUCT ? group : null,
    products
  );

  const groupName =
    groupedBy[0] === GROUP_BY_PRODUCT
      ? productName
      : groupedBy[0] === GROUP_BY_CONTRACT_EXPIRATION
        ? group
        : "";

  return (
    <div className="flex flex-col gap-4">
      <div
        className="flex px-2 py-[6px] gap-3 items-center w-fit cursor-pointer"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <IconButton
          variant="iconNoBg"
          size="md"
          iconClassName={cn(
            "transition-transform duration-200",
            !isExpanded && "-rotate-90"
          )}
        >
          <ChevronDown />
        </IconButton>
        <div className="flex gap-2 items-center">
          <IconContainer size="5">
            <ProductIcon />
          </IconContainer>
          <Text variant="lgLabel">{groupName}</Text>
          {isMultiProduct && (
            <Badge
              text={commercials?.length.toString()}
              className="px-1 py-[1px] rounded"
              textVariant="smBodySecondary"
            />
          )}
        </div>
      </div>
      <div
        className={cn(
          "grid transition-[grid-template-rows] duration-200 ease-in-out",
          isExpanded ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
        )}
      >
        <div className="overflow-hidden flex flex-col gap-6">
          {map(commercials, (commercial) => (
            <CompanyCommercial
              key={commercial?.dealId}
              commercial={commercial}
              products={products}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default CompanyCommercialGroup;
